/*
 * $Id:: utils.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState } from 'react';

import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import Filter1OutlinedIcon from '@material-ui/icons/Filter1Outlined';
import Filter2OutlinedIcon from '@material-ui/icons/Filter2Outlined';
import Filter3OutlinedIcon from '@material-ui/icons/Filter3Outlined';
import Filter4OutlinedIcon from '@material-ui/icons/Filter4Outlined';
import Filter5OutlinedIcon from '@material-ui/icons/Filter5Outlined';
import Filter6OutlinedIcon from '@material-ui/icons/Filter6Outlined';
import Filter7OutlinedIcon from '@material-ui/icons/Filter7Outlined';
import Filter8OutlinedIcon from '@material-ui/icons/Filter8Outlined';
import Filter9OutlinedIcon from '@material-ui/icons/Filter9Outlined';
import Filter9PlusOutlinedIcon from '@material-ui/icons/Filter9PlusOutlined';

import { ReactComponent as CheckIcon } from '../..//assets/images/done_24px.svg';
import { ReactComponent as CaretSingle } from '../../assets/images/caret_single.svg';
import { ReactComponent as DropDownArrow } from '../../assets/images/solid_caret.svg';
import { t } from '../../providers';

const useStyles = makeStyles(() => ({
    valueWithChip: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
    },
    textInput: {
        height: '2rem',
        width: 'auto',
        marginRight: '10px',
        backgroundColor: '#ffffff',
        border: '1px solid #9B9B9B',
        '@media (max-width:1100px)': {
            marginBottom: '20px !important',
        },
        '& input': {
            '&::placeholder': {
                color: '#3F5E20 !important',
                fontSize: '1.125rem',
            },
        },
        '& .MuiSelect-select': {
            borderRadius: '4px',
            paddingRight: '31px',
        },
        '@media (max-width:600px)': {
            width: '100%',
            marginBottom: '8px',
        },
        '& .MuiSelect-icon': {
            top: 'calc(50% - 6px)',
        },
    },
    chip: {
        color: '#3F5E20 !important',
        height: '22px',
        width: '100%',
        display: 'block',
        boxShadow: 'none',
        zIndex: '99',
        paddingRight: '0px',
        background: '#fff',
        textAlign: 'end',
        '& .MuiChip-label': {
            padding: 0,
            display: 'none',
        },
        '& .MuiChip-icon': {
            color: '#3F5E20 !important',
        },
        '@media (max-width:600px)': {
            paddingRight: '11px !important',
        },
    },
    filterSelect: {
        '@media (max-width:600px)': {
            width: '75%',
        },
    },
    disabledMenuItem: {
        color: '#5D5D5D',
        opacity: '1 !important',
    },
    selectDateType: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '0.75rem',
        lineHeight: '160%',
        letterSpacing: '0.5px',
        color: '#586071',
    },
}));

export const customHeaderMultiRangePicker = ({
    classes,
    handleDropdownChange,
    dateType,
    dropdownOptions,
    ranges,
    clearSelectedDate,
    dataTypeNotSelected,
    headerIsOpen,
    setHeaderIsOpen,
}) => {
    const selectedDateTypeLabel = dropdownOptions.find((option) => option.key === dateType);

    const selectOpen = () => {
        setHeaderIsOpen(true);
    };

    const selectClose = () => {
        setHeaderIsOpen(false);
    };

    return (
        <div className={classes.datepickerCustomHeader}>
            <Select
                SelectDisplayProps={{
                    'aria-label': t('select.date.type'),
                    role: 'combobox',
                    'aria-controls': 'date-type-select-list',
                    'aria-expanded': headerIsOpen,
                    'aria-labelledby': undefined,
                }}
                id="date-type-select"
                className={`${classes.textInput} ${dataTypeNotSelected ? classes.inputError : ''}`}
                displayEmpty
                onOpen={selectOpen}
                onClose={selectClose}
                label={t('select.please')}
                onChange={handleDropdownChange}
                value={dateType}
                IconComponent={() => <DropDownArrow aria-hidden="true" focusable="false" />}
                inputProps={{ 'aria-haspopup': 'listbox' }}
                MenuProps={{
                    'aria-haspopup': true,
                    MenuListProps: { role: 'listbox', id: 'date-type-select-list', 'aria-labelledby': 'date-type-select' },
                }}>
                <MenuItem value="" disabled className={classes.disabledMenuItem} role="option">
                    {t('select.date.type')}
                </MenuItem>
                {dropdownOptions.map((option, idx) => {
                    const selected = ranges && ranges.some((range) => range.dateType === option.key);
                    return (
                        <MenuItem key={`${option.key}_${idx}`} value={option.key} className={selected ? classes.selectedDate : ''}>
                            <div className={classes.dateOption}>{t(option.label)}</div>
                            {selected && <CheckIcon />}
                        </MenuItem>
                    );
                })}
            </Select>
            {!selectedDateTypeLabel && (
                <div
                    aria-describedby="date-type-select"
                    className={`${classes.selectDateType} ${dataTypeNotSelected ? classes.selectDateTypeError : ''}`}>
                    {dataTypeNotSelected
                        ? t('please.select.date.type')
                        : t('please.select.date.type').includes('Erro:')
                        ? t('please.select.date.type').replace('Erro:', '')
                        : t('please.select.date.type').replace('Error:', '')}
                </div>
            )}
            {selectedDateTypeLabel && (
                <div>
                    <Button
                        disableFocusRipple
                        className={classes.clearButton}
                        variant="contained"
                        onClick={clearSelectedDate}
                        id={'clearSelectedDate'}>
                        {`${t('clear')} ${t(selectedDateTypeLabel.label)}`}
                    </Button>
                </div>
            )}
        </div>
    );
};

export const customEndAdornmentMultiRangePicker = ({ ranges, classes }) => {
    const selectedRangeLength = (ranges || []).reduce((acc, cur) => {
        return !!cur.dateType && !!cur.startDate && !!cur.endDate ? acc + 1 : acc;
    }, 0);
    const chipIcon = [
        <Filter1OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter2OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter3OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter4OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter5OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter6OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter7OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter8OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter9OutlinedIcon aria-hidden="true" focusable="false" />,
    ];

    const changePlaceHolderColor = () => {
        const dateElement = document.getElementById('dateRanges_datepicker');
        if (!!dateElement) {
            dateElement.classList.toggle('hasDates');
        }
    };

    if (!!selectedRangeLength) {
        changePlaceHolderColor();
    } else {
        changePlaceHolderColor();
    }

    return !!selectedRangeLength ? (
        <>
            <div className={classes.valueWithChip}>
                <Chip
                    className={classes.chip}
                    label={selectedRangeLength - 1}
                    icon={
                        selectedRangeLength <= 9 ? (
                            chipIcon[selectedRangeLength - 1]
                        ) : (
                            <Filter9PlusOutlinedIcon aria-hidden="true" focusable="false" />
                        )
                    }
                />
            </div>

            {selectedRangeLength === 0 && (
                <InputAdornment position="end" className={classes.doubleCarretIcon}>
                    <CaretSingle alt="" />
                </InputAdornment>
            )}
        </>
    ) : null;
};
